// extracted by mini-css-extract-plugin
module.exports = {"total":"total-UFst4","totalTitle":"totalTitle-3eOmI","money":"money-HqXJT","row":"row-3vrY3"};